function removeNonAlphaNumCharacters(input: string) {
  return input.replace(/[^a-zA-Z0-9]/g, '');
}

export const toAlphaNum: React.FormEventHandler<HTMLInputElement> = (e) => {
  const target = e.target as HTMLInputElement;
  target.value = target.value ? removeNonAlphaNumCharacters(target.value) : '';
};
